module.exports = __webpack_public_path__ + "img/headline-boat.16709958.svg";